import React from "react";
import { NavLink } from "react-router-dom";
import "./adminSidebar.css"; 

const AdminSidebar = () => {

   const role = localStorage.getItem("admin_role");

  return (
    <div className="admin-sidebar">
      <h2 className="sidebar-title">Admin Panel</h2>

      {role === "admin" && (
        <>
      {/* Admin Section */}
      <div className="sidebar-section">
        <h3>Admin</h3>
        <NavLink 
          to="/rc_admin_panel/domain" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Domain 
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/products" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Products
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/total_orders" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Total Orders
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/addusers" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Add Users
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/pcbrequests" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Check Pcb Requests
        </NavLink>
        
        <NavLink 
          to="/rc_admin_panel/addmilestone" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Add MileStones
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/addgallerypage" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Add GalleryPage Images
        </NavLink>
        
      </div>

      {/* BDM Section */}
      <div className="sidebar-section">
        <h3>BDM</h3>
        <NavLink 
          to="/rc_admin_panel/admin-products" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Total Products
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/queries" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Queries
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/questions" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Questions
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/reviews" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Reviews
        </NavLink>
         <NavLink 
          to="/rc_admin_panel/quotations" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Quotations
        </NavLink>
        <NavLink 
          to="/rc_admin_panel/poster" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
            Add Poster
        </NavLink>
        
      </div>

    {/*INTERNSHIP SECTION */}
      <div className="sidebar-section">
        <h3>Internships</h3>
        <NavLink 
          to="/rc_admin_panel/slots" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Slots
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/manage_batches" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Batches
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/approveinternships" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Internship Applications
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/amountupdate" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Amount
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/confirminternship" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Confirm Internships
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/internshipapp" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Internships
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/templateupload" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          upload Template
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/updateongoing" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Update Ongoing Internships
        </NavLink>

      </div>
        </>
      )}


      <div className="sidebar-section">
        <h3>INTERN ASSIGNMENT CONTROLS</h3>

         <NavLink 
          to="/rc_admin_panel/intern_assignments" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Assignments
        </NavLink>

        <NavLink 
          to="/rc_admin_panel/assign_assignments"
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Assign Assignments
        </NavLink>
        
         <NavLink 
          to="/rc_admin_panel/submitted_answers" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Manage Submitted Answers
        </NavLink>

         <NavLink 
          to="/rc_admin_panel/intern_profile" 
          className={({ isActive }) => isActive ? "active-link" : ""}
        >
          Intern Profile
        </NavLink>

      </div>

    </div>  
  );
};

export default AdminSidebar;
